import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, MapPin, Tag, QrCode, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/", label: "Start", icon: Home },
  { to: "/standorte", label: "Standorte", icon: MapPin },
  { to: "/wochenmenue", label: "Menü", icon: Tag },
  { to: "/angebote", label: "Angebote", icon: Tag },
];

export default function MobileNav() {
  const loc = useLocation();
  const { user } = useAuth();
  const last = user
    ? { to: user.role === "customer" ? "/mein-konto" : user.role === "employee" ? "/scanner" : "/admin", label: "Konto", icon: QrCode }
    : { to: "/login", label: "Konto", icon: User };
  const items = [...ITEMS.slice(0, 3), { to: "/helium-vorteile", label: "Club", icon: QrCode }, last];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 flex justify-around items-center lg:hidden shadow-[0_-4px_16px_rgba(0,0,0,0.06)]">
      {items.map((it) => {
        const Icon = it.icon;
        const active = loc.pathname === it.to;
        return (
          <Link key={it.to + it.label} to={it.to} data-testid={`bottomnav-${it.label.toLowerCase()}`}
            className={`flex-1 flex flex-col items-center gap-0.5 py-2.5 text-[11px] font-medium ${active ? "text-[#E0243A]" : "text-gray-500"}`}>
            <Icon className="w-5 h-5" strokeWidth={active ? 2.4 : 1.8} />
            {it.label}
          </Link>
        );
      })}
    </nav>
  );
}
